import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getRadius } from "./auth-service-tools185.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useTimelineContext } from "./auth-service-tools421.js";
import classes from "./auth-service-tools423.js";
const defaultProps = {};
const TimelineItem = factory((_props, ref) => {
  const props = useProps("TimelineItem", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    __active,
    __align,
    __lineActive,
    __vars,
    bullet,
    radius,
    color,
    lineVariant,
    children,
    title,
    mod,
    ...others
  } = props;
  const ctx = useTimelineContext();
  const theme = useMantineTheme();
  const stylesApiProps = {
    classNames,
    styles
  };
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, { ...ctx.getStyles("item", { ...stylesApiProps,
      className,
      style
    }),
    mod: [{
      "line-active": __lineActive,
      active: __active
    }, mod],
    ref,
    __vars: {
      "--tli-radius": radius ? getRadius(radius) : void 0,
      "--tli-color": color ? getThemeColor(color, theme) : void 0,
      "--tli-border-style": lineVariant || void 0
    },
    ...others,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...ctx.getStyles("itemBullet", stylesApiProps),
      mod: {
        "with-child": !!bullet,
        align: __align,
        active: __active
      },
      children: bullet
    }), /* @__PURE__ */jsxRuntimeExports.jsxs("div", { ...ctx.getStyles("itemBody", stylesApiProps),
      children: [title && /* @__PURE__ */jsxRuntimeExports.jsx("div", { ...ctx.getStyles("itemTitle", stylesApiProps),
        children: title
      }), /* @__PURE__ */jsxRuntimeExports.jsx("div", { ...ctx.getStyles("itemContent", stylesApiProps),
        children
      })]
    })]
  });
});
TimelineItem.classes = classes;
TimelineItem.displayName = "@mantine/core/TimelineItem";
export { TimelineItem };